import React from "react";
import {classNames} from "../../common/util/util-helpers";

export default function Badge({As = "div", children, type, className, addClass, onClick}) {

    const getBadgeClass = (type = null) => {
        switch (type) {
            case "outline":
                return "bg-inverse text-tm-gray-900 border border-tm-gray-300"
            case "success":
                return "bg-green-600/10 text-green-700"
            case "danger":
                return "bg-red-600/10 text-red-700"
            case "warning":
                return "bg-yellow-600/10 text-yellow-700"
            case "primary":
                return "bg-indigo-600/10 text-indigo-700"
            case "info":
                return "bg-sky-600/10 text-sky-700"
            case "custom":
                return ""
            default:
                return "bg-gray-600/10 text-tm-gray-900"
        }
    }

    return (
        <As
            className={classNames(
                className ?? "text-tm-gray-700 inline-flex text-center px-3 py-0.5 rounded-btn text-sm font-medium whitespace-nowrap",
                getBadgeClass(type),
                addClass
            )}
            onClick={onClick}
        >
            {children}
        </As>
    );
}
